<template>
  <div class="container user-form-wrapper admin-form">
    <UserForm :parentUser="user" :parent="'editUser'"/>
    <br>
    <b-alert :show="dismissCountDown"
             dismissible
             variant="success"
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
      {{ alertText }}
    </b-alert>
  </div>
</template>

<script>
import UserForm from '@/components/UserForm'
export default {
  name: 'EditUser',
  data () {
    return {
      dismissSecs: 3,
      dismissCountDown: 0,
      alertText: 'User successfully updated'
    }
  },
  components: {
    UserForm
  },
  props: {
    user: Object
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  mounted () {
    this.$root.$on('userWasUpdated', () => {
      this.showAlert()
    })
  }
}
</script>

<style scoped>
.user-form-wrapper {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users/EditUser.vue